/** Features a superadmin can switch on for everyone from Admin → Experimental features. */
export const EXPERIMENTAL_FEATURES = ["systemAnalysisOverTime"] as const;
export type ExperimentalFeature = (typeof EXPERIMENTAL_FEATURES)[number];
export type ExperimentalFeatures = Record<ExperimentalFeature, boolean>;

export const DEFAULT_EXPERIMENTAL_FEATURES: ExperimentalFeatures = {
  systemAnalysisOverTime: false,
};

/** Known features from a stored object; anything missing or not `true` is off. */
export function normalizeExperimentalFeatures(value: unknown): ExperimentalFeatures {
  const stored = value && typeof value === "object" ? (value as Record<string, unknown>) : {};
  return Object.fromEntries(
    EXPERIMENTAL_FEATURES.map((feature) => [feature, stored[feature] === true]),
  ) as ExperimentalFeatures;
}
